import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createElement } from 'react';
import { StyledModalContentContainer } from './modal-content.styled';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * ModalContentSlot component.
 *
 * @author Mikhail Siutsou
 * @function ModalContent
 * @category components
 * @param {ModalContentProps} content props.
 * @return {JSX.Element} ModalContentSlot component.
 */
var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var content = typeof children === 'function' ? /*#__PURE__*/createElement(children, _objectSpread({}, restProps)) : children;
  return /*#__PURE__*/_jsx(StyledModalContentContainer, {
    children: content
  });
};

ModalContent.displayName = 'ModalContent';
export { ModalContent };